"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAitoPromoCode = void 0;
const validation_1 = require("../validator/validation");
const datelike_1 = require("../types/datelike");
exports.isAitoPromoCode = (0, validation_1.isObjectOf)({
    promoCode: validation_1.isString,
    validFrom: (0, validation_1.optional)(datelike_1.isISODate),
    validUntil: (0, validation_1.optional)(datelike_1.isISODate),
    discountPercentage: (0, validation_1.optional)(validation_1.isNumber),
    discountAmount: (0, validation_1.optional)(validation_1.isNumber),
    description: (0, validation_1.optional)(validation_1.isString),
    products: (0, validation_1.optional)((0, validation_1.isArrayOf)(validation_1.isString)),
});
//# sourceMappingURL=AitoPromotionCode.js.map